function imageReader(file) {
  return new Promise(resolve => {
    const reader = new FileReader()
    reader.addEventListener('load', () => resolve(reader.result), false)
    reader.readAsDataURL(file)
  })
}

export default imageReader

export async function mediaReader(files) {
  return new Promise(resolve => {
    let response = []
    files.map(file => {
      const size = file.size / 1024 / 1024
      if (size <= 5) {
        const reader = new FileReader()
        reader.onload = e => {
          response = response.concat(e.target['result'])
          if (response.length === files.length) {
            resolve(response)
          }
        }
        reader.readAsDataURL(file)
      } else {
        response = response.concat(file.name)
        if (response.length === files.length) {
          resolve(response)
        }
      }
    })
  })
}
